import React, { createContext, useState, useEffect } from 'react';

export const OpenRouterContext = createContext();

const OPENROUTER_MIN_CREDITS = parseInt(process.env.REACT_APP_OPENROUTER_MIN_CREDITS);

export function OpenRouterProvider({ children }) {
  const [useOpenrouter, setUseOpenrouter] = useState(true);
  const [openrouterCredits, setOpenrouterCredits] = useState(null);

  useEffect(() => {
    const checkOpenrouterCredits = async () => {
      try {
        const openrouterApiKey = process.env.REACT_APP_OPENROUTER_API_KEY;
        if (!openrouterApiKey) {
          setUseOpenrouter(true);
          return;
        }

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3000);

        const response = await fetch('https://openrouter.ai/api/v1/credits', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${openrouterApiKey}`,
          },
          signal: controller.signal
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
          setUseOpenrouter(true);
          return;
        }

        const data = await response.json();
        const totalCredits = data.data.total_credits;
        const totalUsage = data.data.total_usage;
        const balance = totalCredits - totalUsage;

        setOpenrouterCredits(balance);
        setUseOpenrouter(balance >= OPENROUTER_MIN_CREDITS);
      } catch (error) {
        setUseOpenrouter(true);
      }
    };

    checkOpenrouterCredits();
  }, []);

  return (
    <OpenRouterContext.Provider value={{ useOpenrouter, openrouterCredits, OPENROUTER_MIN_CREDITS }}>
      {children}
    </OpenRouterContext.Provider>
  );
}

export function useOpenRouter() {
  return React.useContext(OpenRouterContext);
}
